module.exports = __webpack_public_path__ + "media/images/application/template/logos/iso-14001-2022-fff1a6322f02e95a80947483bf9a29a1.png";